import { useEffect, useState } from "react";
import "./PageTeam.css";
import Bold from "../style/styleBold";
import Typewriter from "../style/typewriterEffect";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const PageTeam = () => {
  const [photoVisible, setPhotoVisible] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>BCGAP Leadership</title>
        <meta
          name="description"
          content="BCGAP Leadership: Grace Bent, Christina Emile, Lita Graham."
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Bent Christy Graduate Assistance Program",
            url: "https://bcgap.org/bent-christy-graduate-assistance-program-our-team",
            member: [
              {
                "@type": "Person",
                name: "Grace Bent",
                jobTitle: "Founder and Chief Executive Officer",
                email: "grace_bent@bcgap.org",
                url: "https://bcgap.org/bent-christy-graduate-assistance-program-our-team-member/0",
              },
              {
                "@type": "Person",
                name: "Christina Emile",
                jobTitle: "Executive Director and Chief Operating Officer",
                email: "christina_emile@bcgap.org",
                url: "https://bcgap.org/bent-christy-graduate-assistance-program-our-team-member/1",
              },
              {
                "@type": "Person",
                name: "Lita Graham",
                jobTitle: "Director of Chief Creative Officer",
                email: "lita_graham@bcgap.org",
                url: "https://bcgap.org/bent-christy-graduate-assistance-program-our-team-member/2",
              },
            ],
          })}
        </script>
      </Helmet>
      <div className="team-page">
        <div className="team-header">
          <Typewriter text="being the change we need to see" />
        </div>
        <div className="glyph">
          <img
            width="64"
            height="64"
            src="https://img.icons8.com/hatch/64/expand-arrow.png"
            alt="expand-arrow"
          />
        </div>
        <div className="team-intro">
          <div className="leadership-subheader">Our Leadership</div>
          <span>
            Meet the dynamic team leading the{" "}
            <Bold>Bent Christy Graduate Assistance Program</Bold> efforts to
            create a future where financial barriers or the weight of student
            debt no longer prevent individuals from reaching their full
            potential.
          </span>
        </div>
        <div className="team-container">
          <div className="photo-block">
            <a href="/bent-christy-graduate-assistance-program-our-team-member/0">
              <div className="team-photo">
                <img src="./images/about/grace_bent.png" alt="Grace Bent" />
              </div>
              <div className="photo-caption">
                <div className="photo-caption-name">
                  Grace Bent{" "}
                  <span className="team-read-more">
                    <img
                      src="https://img.icons8.com/fluency-systems-regular/e93402/96/external-link.png"
                      alt="external-link"
                    />
                  </span>
                </div>
                <div className="photo-caption-role">
                  Founder and Chief Executive Officer{" "}
                </div>
                <div className="photo-caption-email">
                  <img
                    src="https://img.icons8.com/pastel-glyph/27313a/64/new-post--v1.png"
                    alt="email"
                  />
                  grace_bent@bcgap.org
                </div>
              </div>
            </a>
          </div>
          <div className="photo-block">
            <a href="/bent-christy-graduate-assistance-program-our-team-member/1">
              <div className="team-photo">
                <img
                  style={{ objectPosition: "0 0" }}
                  src="./images/home/christina_photo_2.webp"
                  alt="Christina Emile"
                />
              </div>
              <div className="photo-caption">
                <div className="photo-caption-name">
                  Christina Emile{" "}
                  <span className="team-read-more">
                    <img
                      src="https://img.icons8.com/fluency-systems-regular/e93402/96/external-link.png"
                      alt="external-link"
                    />
                  </span>
                </div>
                <div className="photo-caption-role">
                  Executive Director and Chief Operating Officer{" "}
                </div>
                <div className="photo-caption-email">
                  <img
                    src="https://img.icons8.com/pastel-glyph/27313a/64/new-post--v1.png"
                    alt="email"
                  />
                  christina_emile@bcgap.org
                </div>
              </div>
            </a>
          </div>
          <div className="photo-block">
            <a href="/bent-christy-graduate-assistance-program-our-team-member/2">
              <div className="team-photo">
                <img
                  style={{ objectPosition: "0 0" }}
                  src="./images/home/lita_photo_2.webp"
                  alt="Lita Graham"
                />
              </div>
              <div className="photo-caption">
                <div className="photo-caption-name">
                  Lita Graham{" "}
                  <span className="team-read-more">
                    <img
                      src="https://img.icons8.com/fluency-systems-regular/e93402/96/external-link.png"
                      alt="external-link"
                    />
                  </span>
                </div>
                <div className="photo-caption-role">
                  Director of Chief Creative Officer{" "}
                </div>
                <div className="photo-caption-email">
                  <img
                    src="https://img.icons8.com/pastel-glyph/27313a/64/new-post--v1.png"
                    alt="email"
                  />
                  lita_graham@bcgap.org
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default PageTeam;
